export function isUntouchedAudienceParameter(parameter) {
    if (!parameter) return true;
    const parameterName = parameter.parameterData?.parameterName;
    return !parameterName
        && !parameter.operator
        && !parameter.paramValue
        && !parameter.paramFromValue
        && !parameter.paramToValue
        && !parameter.offerId
        && !parameter.offset;
}

export function resetAudienceParameterErrors(parameter) {
    parameter.paramNameError = false;
    parameter.operatorError = false;
    parameter.operatorValueError = false;
    parameter.valueError = false;
    parameter.offerValueError = false;
    parameter.offsetValueError = false;
}

export function hasAudienceValidationErrors(audiences, allowUntouched = false) {
    return (audiences || []).flatMap(audience => audience.parameters || []).some(parameter => {
        if (allowUntouched && isUntouchedAudienceParameter(parameter)) return false;
        return parameter.paramNameError === true
            || parameter.operatorError === true
            || parameter.operatorValueError === true
            || parameter.valueError === true
            || parameter.offerValueError === true
            || parameter.offsetValueError === true;
    });
}
